module.exports = __webpack_public_path__ + "img/banner6@2x.a0c147ec.png";